import {
  ModalCard, ModalRoot, SplitCol, SplitLayout
} from '@vkontakte/vkui';
import { useUnit } from 'effector-react';
import { ReactNode, memo, useCallback } from 'react';
import { setActivePanel } from 'src/entity/ActivePanel';
import { MessagesTypesT, messagesTypes } from 'src/entity/Messages';
import { Mods, classNames } from 'src/shared/lib/helpers/classNames';
import { SuperBtn } from 'src/shared/ui/superBtn';

import bridge from '@vkontakte/vk-bridge';

import { AppPanels } from '../../RouteProvider/lib/routeConfig';
import styles from './styles.module.scss';

const modalMessages: Record<MessagesTypesT, string> = {
  [messagesTypes.FILL_ERROR]: 'Заполните все поля',
  [messagesTypes.POST_ERROR]:
    'Что-то пошло не так, попробуйте снова немного позже',
  [messagesTypes.STATUS_ERROR]: 'Выбрать свой эмодзи-статус можно после голосования за Главных Героев!',
  [messagesTypes.SHARE_POSTCARD_ERROR]: 'Ошибка при загрузке изображения на сервер. Попробуйте еще раз.',
  [messagesTypes.SET_IMAGE_STATUS_SUCCESS]: 'Ура! Статус успешно установлен',
  [messagesTypes.SET_IMAGE_STATUS_ERROR]: 'Ошибка при установке статуса изображения, попробуйте немного позже'
};

export interface IModal {
  messageType?: MessagesTypesT | null;
  onClose?: () => void;
}

export const ModalProvider = memo(({ messageType, onClose }: IModal) => {
  const onSetActivePanel = useUnit(setActivePanel);

  // Актуально для второго этапа голосования
  const onStatusErrorActionClick = useCallback(() => {
    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      event: 'vote_click',
      screen: 'modal'
    });
    onSetActivePanel(AppPanels.SECOND_STAGE_NOMINATIONS);
    onClose?.();
  }, [onSetActivePanel, onClose]);

  if (!messageType) {
    return null;
  }

  const actions: Record<MessagesTypesT, ReactNode[]> = {
    [messagesTypes.FILL_ERROR]: [],
    [messagesTypes.POST_ERROR]: [],
    [messagesTypes.SHARE_POSTCARD_ERROR]: [],
    [messagesTypes.SET_IMAGE_STATUS_SUCCESS]: [],
    [messagesTypes.SET_IMAGE_STATUS_ERROR]: [],
    [messagesTypes.STATUS_ERROR]: [
      <SuperBtn
        text='Голосовать'
        color='3'
        key={1}
        onClick={onStatusErrorActionClick}
      />
    ]
  };

  const mods: Mods = {
    [styles.success]: messageType.includes('success')
  };

  const modals = (
    <ModalRoot activeModal='faq'>
      <ModalCard
        className={classNames(styles.modal, mods)}
        onClose={onClose}
        id='faq'
        actions={actions[messageType]}
      >
        {messageType && modalMessages[messageType]}
      </ModalCard>
    </ModalRoot>
  );

  return (
    <SplitLayout id='layout' modal={modals}>
      <SplitCol id='col' />
    </SplitLayout>
  );
});
